module.exports = __webpack_public_path__ + "media/images/convenios/aso_odontologica (copia)-41731862d48adecefdc72af1ac2264c0.jpg";